import { render, staticRenderFns } from "./DokoLoginLogo.vue?vue&type=template&id=5fd9ce71&"
import script from "./DokoLoginLogo.vue?vue&type=script&lang=ts&"
export * from "./DokoLoginLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports